import { AlertEnum } from '../enums';
import { Navigate } from 'react-router-dom';
import React from 'react';
import { useAlert } from '../hooks';
import useAuth from '../hooks/useAuth';
import { useTranslation } from 'react-i18next';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { authenticated } = useAuth();
  const { createAlert } = useAlert();
  const { t } = useTranslation();

  if (!authenticated) {
    createAlert(t('erro.usuario_nao_autenticado'), AlertEnum.ERROR);
    return <Navigate to="/" />;
  }

  return children;
}

export default RequireAuth;
